import React, { FunctionComponent } from 'react';
import { useScreenSize } from '../../../hooks/useScreenSize';
import { PagePath, SanityImage, SanityNavLink, SanityTeaser } from '../../../types/common';
import { urlFor } from '../../../utils/imageBuilder';
import { InternalLinkIcon } from '../../Icons';
import InternalLink from '../../InternalLink';
import PageHeaderLinks from '../../PageHeaderLinks';
import './styles.scss';

type Page = {
  title: string;
  image?: SanityImage | null;
  teaser?: SanityTeaser | null;
  navItems?: SanityNavLink[] | null;
} & PagePath;

type DoubleFeaturedPagesProps = {
  data: {
    firstPage: Page;
    secondPage: Page;
    htmlId: string | null;
  };
}

const DoubleFeaturedPages: FunctionComponent<DoubleFeaturedPagesProps> = ({ data }) => {
  const pages = [data.firstPage, data.secondPage]

  const { isMobile } = useScreenSize();
  const Tag = isMobile ? InternalLink : 'div';

  return (
    <section className='double-featured-pages' id={data.htmlId || undefined}>
      {pages.map((page) => {
        const image = page.teaser?.image?.asset ? page.teaser.image : page.image!;

        return (
          <Tag
            key={page._id}
            reference={page}
            className='teaser'
          >
            {(page.teaser?.image?.asset || page.image?.asset) && (
              <div className='teaser-image'>
                <picture>
                  <source media="(min-width:992px)" srcSet={urlFor(image).width(650).quality(100).url()} />
                  <source media="(min-width:650px)" srcSet={urlFor(image).width(1000).quality(100).url()} />
                  <img
                    src={urlFor(image).width(650).quality(100).url()}
                    alt={image.alt}
                  />
                </picture>

                {/* <img
                  src={urlFor(page.teaser?.image?.asset ? page.teaser.image : page.image!).quality(90).url()}
                  alt={page.teaser?.image?.alt ? page.teaser.image.alt : page.image!.alt}
                /> */}
              </div>
            )}
            <div className='teaser-header'>
              <div className='teaser-header-texts'>
                <h2>{page.teaser?.title ? page.teaser.title : page.title}</h2>
                {page.teaser?.description && (
                  <p>{page.teaser.description}</p>
                )}
              </div>
              <InternalLinkIcon />
            </div>
            {!isMobile && page.navItems && (
              <div className='teaser-links'>
                <PageHeaderLinks
                  links={page.navItems}
                />
              </div>
            )}
            {!isMobile && (
              <InternalLink
                reference={page}
                className='primary-button'
              >
                {page.teaser?.cta ? page.teaser.cta : 'Learn more'}
                <InternalLinkIcon />
              </InternalLink>
            )}
          </Tag>
        )
      })}
    </section>
  );
}

export default DoubleFeaturedPages;
